<template>
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
        <div :class="data.bgColor">
            <div class="inner-bag-box">
                <p>Current {{ data.title }}: {{ data.num }}</p>
                <h3>{{ data.name }}</h3>
                <span v-html="data.description">
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModuleBoxVue',
    props: {
        // Define the prop name and type
        ModuleData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: {}
        }
    },
    watch: {
        ModuleData: {
            immediate: true, // Execute the handler immediately on mount
            handler(newData) {
                this.data = newData;
            }
        }
    }
}
</script>